import fixings from '@/helpers/rave/constants/fixings'

export default {
  [fixings.NONE]: '',
  [fixings.DETRIMENT]: 'Detriment',
  [fixings.EXALTED]: 'Exalted',
  [fixings.JUXTAPOSED]: 'Juxtaposed'
}
